'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconHorizontalTriangleOutline, iconHorizontalTriangleOutlineTag } from '@ni/nimble-components/dist/esm/icons/horizontal-triangle-outline';
import { wrap } from '../../utilities/react-wrapper';

export type { IconHorizontalTriangleOutline };
export { iconHorizontalTriangleOutlineTag };
export const NimbleIconHorizontalTriangleOutline = wrap(IconHorizontalTriangleOutline);